module.exports = __webpack_public_path__ + "c3386e0406b0ea6b7be4e23e2fc60ac1.svg";